import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import api from "@/lib/api";

const BADGE_INITIAL = { opacity: 0, y: -20, scale: 0.9 };
const BADGE_ANIMATE = { opacity: 1, y: 0, scale: 1 };
const BADGE_TRANSITION = { type: "spring", stiffness: 220, damping: 18, delay: 0.3 };
const monthLabel = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("it-IT", { month: "long" });
};

export function StoreOfMonthBadge({ storeId, contestId, accent }) {
  const [top, setTop] = useState(null);
  useEffect(() => {
    if (!storeId) return;
    const load = () => fetch(api.storeOfTheMonthUrl(contestId)).then((r) => r.json()).then(setTop).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [storeId, contestId]);

  if (!storeId || !top?.store || top.store.store_id !== storeId) return null;
  return (
    <motion.div
      initial={BADGE_INITIAL}
      animate={BADGE_ANIMATE}
      transition={BADGE_TRANSITION}
      className="absolute top-[3vmin] left-[3vmin] flex items-center gap-[1.5vmin] rounded-full pl-[1.2vmin] pr-[2.4vmin] py-[1vmin] shadow-2xl text-slate-900"
      style={{ background: accent || "#f59e0b" }}
      data-testid="store-of-month-badge"
    >
      <span className="grid place-items-center h-[6vmin] w-[6vmin] rounded-full bg-white/90"><Trophy className="h-[3.5vmin] w-[3.5vmin] text-amber-500" /></span>
      <div className="text-left leading-tight">
        <p className="font-display font-black text-[2.6vmin] uppercase tracking-wide">Punto vendita del mese</p>
        <p className="text-[1.9vmin] font-semibold capitalize">{monthLabel(top.month)} · {top.store.plays} giocate · {top.store.wins} premi</p>
      </div>
    </motion.div>
  );
}
